{
  "title": "Notifications",
  "loading": "Loading…",
  "empty": "Nothing new yet.",
  "markAllRead": "Mark all read",
  "unreadCount_one": "Notifications, {{count}} unread",
  "unreadCount_other": "Notifications, {{count}} unread",
  "seeAll": "See all notifications",
  "inbox": {
    "title": "Notifications",
    "description": "Everything the school sent you.",
    "unreadOnly": "Unread only",
    "kind": "Type",
    "allKinds": "All types",
    "open": "Open",
    "unread": "Unread",
    "markedAllRead": "All notifications marked as read.",
    "clearFilters": "Clear filters"
  },
  "kinds": {
    "homework_assigned": "Homework assigned",
    "homework_graded": "Homework graded",
    "homework_returned": "Homework returned",
    "test_assigned": "Test assigned",
    "attempt_graded": "Test graded",
    "announcement": "Announcement",
    "message": "New message",
    "invitation": "Invitation",
    "project_assigned": "Project assigned",
    "project_graded": "Project graded",
    "due_soon": "Due soon"
  },
  "preferences": {
    "title": "Notification preferences",
    "description": "How this school reaches you. These settings are per school.",
    "inApp": "Show notifications in the app",
    "inAppHint": "The inbox always records what happened; this controls the badge and the bell.",
    "email": "Send me email",
    "emailHint": "Turn this off and email stops entirely, whatever the digest setting says.",
    "digest": "Email frequency",
    "digestModes": {
      "instant": "As it happens",
      "daily": "Daily digest",
      "weekly": "Weekly digest",
      "off": "No email"
    },
    "parentNote": "Parents start on the weekly digest so a school week arrives as one email instead of thirty. Change it here at any time.",
    "saved": "Preferences saved.",
    "loading": "Loading preferences…"
  },
  "emptyText": "Homework, grades, announcements and messages land here as they happen.",
  "emptyFiltered": {
    "title": "Nothing matches these filters",
    "text": "No notification of this type is waiting. Clear the filters to see the whole inbox."
  }
}
